var _defs, _path, _text, _text2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSiloSeries01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 900 530",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-7,.cls-8{letter-spacing:-.11em}.cls-10,.cls-9{letter-spacing:-.02em}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 16.25h857v24H18zm0 51.72h857v24H18zm0 51.72h857v24H18zm0 51.73h857v24H18zm0 51.72h857v24H18zm0 79.44h857v24H18zm0 52.73h857v49.44H18zm0 76.72h857v24H18zm0 52.72h857v24H18z",
    fill: "#333",
    opacity: 0.5
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    transform: "translate(25.38 34.19)",
    fontFamily: "WintonNeue",
    fontSize: 18,
    fontWeight: 500,
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Body "), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-8",
    x: 48.69,
    y: 0
  }, "T"), /*#__PURE__*/React.createElement("tspan", {
    x: 57.37,
    y: 0
  }, "ype"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 26
  }, "Compartments"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 52
  }, "Manholes"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-8",
    x: 0,
    y: 78
  }, "T"), /*#__PURE__*/React.createElement("tspan", {
    x: 8.68,
    y: 78
  }, "est P"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-9",
    x: 51.03,
    y: 78
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    x: 57.04,
    y: 78
  }, "essu"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-9",
    x: 96.06,
    y: 78
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    x: 102.08,
    y: 78
  }, "e"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 104
  }, "Operating P"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-9",
    x: 99.38,
    y: 104
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    x: 105.39,
    y: 104
  }, "essu"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-9",
    x: 144.41,
    y: 104
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    x: 150.42,
    y: 104
  }, "e"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 130
  }, "Operating "), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-8",
    x: 87.37,
    y: 130
  }, "T"), /*#__PURE__*/React.createElement("tspan", {
    x: 96.05,
    y: 130
  }, "emperatu"), /*#__PURE__*/React.createElement("tspan", {
    x: 175.39,
    y: 130,
    letterSpacing: "-.02em"
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    x: 181.4,
    y: 130
  }, "e"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 156
  }, "Fluidizer"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 182
  }, "Discharge"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 208,
    letterSpacing: "-.04em"
  }, "W"), /*#__PURE__*/React.createElement("tspan", {
    x: 16.33,
    y: 208
  }, "alkway"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 234
  }, "Axle G"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-9",
    x: 54.68,
    y: 234
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    x: 60.7,
    y: 234
  }, "oup"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 286
  }, "Ti"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-9",
    x: 15.01,
    y: 286
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    x: 21.02,
    y: 286
  }, "es and Rims"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 312
  }, "Brakes"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 338
  }, "General Information"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 390
  }, "Surface "), /*#__PURE__*/React.createElement("tspan", {
    x: 69.03,
    y: 390,
    letterSpacing: "-.09em"
  }, "T"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-9",
    x: 78.05,
    y: 390
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    x: 84.06,
    y: 390
  }, "eatment"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 416
  }, "G"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-9",
    x: 13.66,
    y: 416
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    x: 19.67,
    y: 416
  }, "oss "), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-9",
    x: 54.04,
    y: 416
  }, "W"), /*#__PURE__*/React.createElement("tspan", {
    x: 70.7,
    y: 416
  }, "eight"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 442,
    letterSpacing: "-.1em"
  }, "T"), /*#__PURE__*/React.createElement("tspan", {
    x: 8.87,
    y: 442
  }, "a"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-9",
    x: 18.88,
    y: 442
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    x: 24.89,
    y: 442
  }, "e "), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-9",
    x: 39.91,
    y: 442
  }, "W"), /*#__PURE__*/React.createElement("tspan", {
    x: 56.57,
    y: 442
  }, "eight"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 468
  }, "Payload Capacity"))), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    transform: "translate(279.38 34.33)",
    fill: "#fff",
    fontFamily: "WintonNeue",
    fontSize: 17
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Aluminium "), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-7",
    x: 84.42,
    y: 0
  }, "T"), /*#__PURE__*/React.createElement("tspan", {
    x: 92.29,
    y: 0
  }, "ank"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 26
  }, "2"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 52
  }, "2 x DN450 aluminum covers with 4 clamps"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 78
  }, "3 bar"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 104
  }, "2 bar"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 130
  }, "-40\xB0C / +80\xB0C"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 156
  }, "Solimar "), /*#__PURE__*/React.createElement("tspan", {
    x: 62.34,
    y: 156,
    letterSpacing: "-.09em"
  }, "T"), /*#__PURE__*/React.createElement("tspan", {
    x: 70.53,
    y: 156
  }, "riple System or Muhlen Sohn Filter Fabric"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 182
  }, "2 bar pneumatic discha"), /*#__PURE__*/React.createElement("tspan", {
    x: 178.57,
    y: 182,
    letterSpacing: "-.03em"
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    x: 183.75,
    y: 182
  }, "ge with WINTON Quick Discha"), /*#__PURE__*/React.createElement("tspan", {
    x: 416.42,
    y: 182,
    letterSpacing: "-.03em"
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    x: 421.61,
    y: 182
  }, "ge Nozzle"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 208
  }, "Aluminum walkway with 1-meter handrail and 400 mm wide ladder"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 234
  }, "SAF / BPW 3 x 9 t disc-braked, maintenance-f"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-10",
    x: 351.73,
    y: 234
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    x: 357.08,
    y: 234
  }, "ee, ai"), /*#__PURE__*/React.createElement("tspan", {
    x: 397.7,
    y: 234,
    letterSpacing: "-.05em"
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    x: 402.42,
    y: 234
  }, "-suspended axles, "), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 260
  }, "factory-mounted with original brackets"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 286
  }, "385/65 R 22.5 BRIDGESTONE / MICHELIN ti"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-10",
    x: 340.37,
    y: 286
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    x: 345.72,
    y: 286
  }, "es on ALCOA / ALUX rims"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 312
  }, "ABS/EBS brake system (ECE R 13 compliant)"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-7",
    x: 0,
    y: 338
  }, "T"), /*#__PURE__*/React.createElement("tspan", {
    x: 7.87,
    y: 338
  }, "wo-tier PVC hose carriers, PVC toolbox, ADR-compliant electrical system"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 364
  }, "(ECE R 105)"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 390
  }, "2 layers of epoxy primer and 2 layers of acrylic paint with a baked-on finish"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 416
  }, "35.500 kg"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 442
  }, "4.200 kg"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 468
  }, "31.300 kg"))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSiloSeries01);
export default __webpack_public_path__ + "static/media/SiloSeries-01.c048b425dd1c070fd46b594b3ac17677.svg";
export { ForwardRef as ReactComponent };